import React from 'react';
import './Footer.css';

const Footer = (props) => {
  return (
    <footer className="footer">
        <div className="container">
            <div className="footer__body">
                Make with love by Oleynik
            </div>
        </div>
    </footer>
  );
}

export default Footer;
